"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScoreOutputIndex = exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var HAZARDOUS_DRINKING = "HAZARDOUS_DRINKING";
var questions = [{
  prompt: "Here’s the first question: How often do you have a drink containing alcohol?",
  type: "radio",
  options: ["Never", "Monthly or less", "2 - 4 times a month", "2 - 3 times a week", "4 or more times a week"],
  pointScale: [0, 1, 2, 3, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "Here’s the first question: How often do you have a drink containing alcohol?"
  }
}, {
  prompt: "A standard drink is 285mL of beer, 100mL of wine or 30mL of spirits. How many standard drinks do you have on a typical day when you are drinking?",
  type: "radio",
  options: ["1 or 2", "3 or 4", "5 or 6", "7 or 8", "10 or more"],
  pointScale: [0, 1, 2, 3, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "A standard drink is 285mL of beer, 100mL of wine or 30mL of spirits. How many standard drinks do you have on a typical day when you are drinking?"
  }
}, {
  prompt: "How often do you have six or more standard drinks on one occasion?",
  type: "radio",
  options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"],
  pointScale: [0, 1, 2, 3, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "How often do you have six or more standard drinks on one occasion?"
  }
}, {
  prompt: "How often during the last year have you found that you were not able to stop drinking once you had started?",
  type: "radio",
  options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"],
  pointScale: [0, 1, 2, 3, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "How often during the last year have you found that you were not able to stop drinking once you had started?"
  }
}, {
  prompt: "How often during the last year have you failed to do what was normally expected of you because of drinking?",
  type: "radio",
  options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"],
  pointScale: [0, 1, 2, 3, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "How often during the last year have you failed to do what was normally expected of you because of drinking?"
  }
}, {
  prompt: "How often during the last year have you needed a first drink in the morning to get yourself going after a heavy drinking session?",
  type: "radio",
  options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"],
  pointScale: [0, 1, 2, 3, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "How often during the last year have you needed a first drink in the morning to get yourself going after a heavy drinking session?"
  }
}, {
  prompt: "How often during the last year have you had a feeling of guilt or remorse after drinking?",
  type: "radio",
  options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"],
  pointScale: [0, 1, 2, 3, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "How often during the last year have you had a feeling of guilt or remorse after drinking?"
  }
}, {
  prompt: "How often during the last year have you been unable to remember what happened the night before because you had been drinking?",
  type: "radio",
  options: ["Never", "Less than monthly", "Monthly", "Weekly", "Daily or almost daily"],
  pointScale: [0, 1, 2, 3, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "How often during the last year have you been unable to remember what happened the night before because you had been drinking?"
  }
}, {
  prompt: "Have you or someone else been injured because of your drinking?",
  type: "radio",
  options: ["No", "Yes, but not in the last year", "Yes, during the last year"],
  pointScale: [0, 2, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "Have you or someone else been injured because of your drinking?"
  }
}, {
  prompt: "Has a relative, friend, doctor, or other health care worker been concerned about your drinking or suggested you cut down?",
  type: "radio",
  options: ["No", "Yes, but not in the last year", "Yes, during the last year"],
  pointScale: [0, 2, 4],
  batteryId: HAZARDOUS_DRINKING,
  meta: {
    summaryTitle: "Has a relative, friend, doctor, or other health care worker been concerned about your drinking or suggested you cut down?"
  }
}];
exports.questions = questions;

var getScoreOutputIndex = function getScoreOutputIndex(score) {
  if (score >= 0 && score <= 7) {
    return 0;
  } else if (score >= 8 && score <= 15) {
    return 1;
  } else if (score >= 16 && score <= 19) {
    return 2;
  } else if (score >= 20 && score <= 40) {
    return 3;
  }
};

exports.getScoreOutputIndex = getScoreOutputIndex;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;